import React from 'react';
import './styles.scss';

export default function Footer() {
  return (
        <footer>
            <p>Photos by
              <span className="authors">
              <a href="https://unsplash.com/@fridooh?utm_source=giulia-teggi-memory-game&utm_medium=referral">Frida Bredesen</a>,
              <a href="https://unsplash.com/@lexmelony?utm_source=giulia-teggi-memory-game&utm_medium=referral">Lex Melony</a>,
              <a href="https://unsplash.com/@rhino007?utm_source=giulia-teggi-memory-game&utm_medium=referral">Keith Markilie</a>,
              <a href="https://unsplash.com/@mana5280?utm_source=giulia-teggi-memory-game&utm_medium=referral">mana5280</a>,
              <a href="https://unsplash.com/@davidclode?utm_source=giulia-teggi-memory-game&utm_medium=referral">David Clode</a>,
              <a href="https://unsplash.com/@valeria_h?utm_source=giulia-teggi-memory-game&utm_medium=referral">Valeria Hutter</a>,
              <a href="https://unsplash.com/@judowoodo?utm_source=giulia-teggi-memory-game&utm_medium=referral">Jude Infantini</a>,
              <a href="https://unsplash.com/@blreak14?utm_source=giulia-teggi-memory-game&utm_medium=referral">Brianna R.</a>,
              <a href="https://unsplash.com/@mooncolonytn60?utm_source=giulia-teggi-memory-game&utm_medium=referral">Niranjan Venkatesh</a> and
              <a href="https://unsplash.com/@majc0?utm_source=giulia-teggi-memory-game&utm_medium=referral">Martin Brechtl</a>
              </span>
            via <a href="https://unsplash.com/?utm_source=giulia-teggi-memory-game&utm_medium=referral">Unsplash</a></p>
        </footer>
  );
}
